import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@api/client';
import { getPresetMenu, presetMenusQueryKeys } from '@api/presetMenus';

interface UsePresetMenuOptions {
  enabled?: boolean;
}

// Single preset menu fetch (expanded view + edit page). `select` unwraps the
// `{preset_menu}` envelope so callers get the ApiPresetMenuDetail directly.
export function usePresetMenu(id: number, { enabled = true }: UsePresetMenuOptions = {}) {
  return useQuery({
    queryKey: presetMenusQueryKeys.detail(id),
    queryFn: () => getPresetMenu(id),
    staleTime: 30_000,
    enabled,
    select: (data) => data.preset_menu,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
